// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wRsht","large":"Header_large__Yz95j","title":"Header_title__kwx0G"};